import React from 'react';
import { Check } from 'lucide-react';

/**
 * ProgressSteps — visual section progress bar for registration forms
 * @param {string[]} steps — step labels
 * @param {number} activeStep — 0-indexed active step (highlight)
 */
export const ProgressSteps = ({ steps, activeStep = 0 }) => {
  return (
    <div className="w-full" data-testid="progress-steps">
      {/* Desktop layout */}
      <div className="hidden sm:flex items-center">
        {steps.map((step, i) => {
          const isDone = i < activeStep;
          const isCurrent = i === activeStep;
          const isLast = i === steps.length - 1;
          return (
            <React.Fragment key={i}>
              <div className="flex flex-col items-center gap-1.5 flex-shrink-0">
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold border-2 transition-all ${
                    isDone
                      ? 'bg-[#16a34a] border-[#16a34a] text-white'
                      : isCurrent
                      ? 'bg-[#0B0B0B] border-[#0B0B0B] text-white'
                      : 'bg-white border-[#E5E5E5] text-[#bbb]'
                  }`}
                  data-testid={`step-circle-${i}`}
                >
                  {isDone ? <Check size={13} /> : String(i + 1).padStart(2, '0')}
                </div>
                <span
                  className={`text-[10px] font-semibold uppercase tracking-wider whitespace-nowrap ${
                    isDone
                      ? 'text-[#16a34a]'
                      : isCurrent
                      ? 'text-[#0B0B0B]'
                      : 'text-[#bbb]'
                  }`}
                >
                  {step}
                </span>
              </div>
              {!isLast && (
                <div
                  className={`flex-1 h-0.5 mx-2 rounded ${
                    i < activeStep ? 'bg-[#16a34a]' : 'bg-[#E5E5E5]'
                  }`}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>

      {/* Mobile layout — compact dots */}
      <div className="flex sm:hidden items-center gap-1.5">
        {steps.map((step, i) => {
          const isDone = i < activeStep;
          const isCurrent = i === activeStep;
          return (
            <React.Fragment key={i}>
              <div
                className={`w-6 h-6 rounded-full flex items-center justify-center text-[10px] font-bold flex-shrink-0 ${
                  isDone
                    ? 'bg-[#16a34a] text-white'
                    : isCurrent
                    ? 'bg-[#0B0B0B] text-white'
                    : 'bg-[#E5E5E5] text-[#bbb]'
                }`}
              >
                {isDone ? <Check size={10} /> : i + 1}
              </div>
              {i < steps.length - 1 && (
                <div className={`flex-1 h-0.5 ${i < activeStep ? 'bg-[#16a34a]' : 'bg-[#E5E5E5]'}`} />
              )}
            </React.Fragment>
          );
        })}
        <span className="ml-2 text-xs font-semibold text-[#0B0B0B] whitespace-nowrap">
          {steps[activeStep]}
        </span>
      </div>
    </div>
  );
};

export default ProgressSteps;
